import React from "react";
import { Link, useParams } from "react-router-dom";

import utils from "../../../../../../shared/utils";

import "./styles.css";

export default function AgendaBlock({ date, title, code }) {
  const { accessType } = useParams();

  return (
    <Link to={`/${accessType}/conteudo/${utils.slugifyTitle(title)}_${code}`}>
      <div className="agendaHome__block">
        <div className="agendaHome__data">
          <p dangerouslySetInnerHTML={{ __html: date }}></p>
        </div>
        <div className="agendaHome__descricao">
          <p>{title}</p>
        </div>
      </div>
    </Link>
  );
}
